import { resolveMediaUrl } from "../utils/resolveMediaUrl";
import { publicBrandText } from "../utils/brandText";
import { buildElivaasDetailPath, extractElivaasProviderId } from "../utils/providerRoutes";
import { fallbackImage } from "./data/mobileFallbackData";

export const asArray = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
};

export const formatPrice = (value, currency = "INR") => {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return "On request";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
};

const mediaValue = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value.image_url || value.imageUrl || value.url || value.src || value.path || value.original || value.large || "";
};

export const normalizePropertyCard = (item = {}, index = 0) => {
  const providerId = extractElivaasProviderId(item);
  const providerLink = providerId ? buildElivaasDetailPath(item) : "";
  const rawImage =
    item.thumbnail ||
    item.thumbnail_url ||
    item.featured_image ||
    item.coverImage ||
    item.cover_image ||
    item.image_url ||
    item.image ||
    (Array.isArray(item.images) ? item.images[0] : "");
  const price =
    item.display_price ||
    item.display_sell_price ||
    item.final_per_night_display_price ||
    item.sell_price_per_night ||
    item.sellPricePerNight ||
    item.price_per_night ||
    item.base_price_per_night ||
    item.price_from ||
    item.price;
  const minimumStayNights = Number(item.minimum_stay_nights || item.minimumStayNights || 0) || null;
  const priceSubtitle =
    item.price_subtitle ||
    item.priceSubtitle ||
    item.display_price_label ||
    (minimumStayNights > 1 ? `Min. ${minimumStayNights}-night stay` : "/ night");

  return {
    raw: item,
    id: String(item.id || item.slug || `mobile-property-${index}`),
    title: publicBrandText(item.title || item.name || item.property_name || "Homevilas stay"),
    location: [item.area, item.city, item.state].filter(Boolean).join(", ") || item.location || "India",
    image: resolveMediaUrl(mediaValue(rawImage), { width: 720, height: 520, fit: "cover", quality: 72 }) || fallbackImage,
    price,
    priceSubtitle,
    priceLabel: item.display_price_label || item.priceLabel || "",
    minimumStayNights,
    minimumStayTotal: item.minimum_stay_total || item.minimumStayTotal || item.total_stay_amount || null,
    totalStayAmount: item.total_stay_amount || item.totalStayAmount || null,
    displayPriceUnit: item.display_price_unit || item.displayPriceUnit || "",
    currency: item.currency || "INR",
    badge: item.badge || item.tag || item.highlight || "",
    rating: item.avg_rating || item.rating || "",
    guests: item.max_guests || item.guests || "",
    bedrooms: item.bedrooms || "",
    bathrooms: item.bathrooms || "",
    link:
      item.detail_path ||
      item.link ||
      (providerLink
        ? providerLink
        : item.slug
        ? `/property/${item.slug}`
        : "/stays"),
    amenities: Array.isArray(item.amenities) ? item.amenities : [],
    images: [rawImage, ...(Array.isArray(item.images) ? item.images : [])]
      .map(mediaValue)
      .filter(Boolean)
      .filter((value, position, values) => values.indexOf(value) === position)
      .map((value) => resolveMediaUrl(value, { width: 900, height: 720, fit: "cover", quality: 78 })),
    description: publicBrandText(item.long_description || item.description || item.short_description || ""),
  };
};

export const buildQuery = (values = {}) => {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    params.set(key, String(value));
  });
  return params.toString();
};
